import axios from "axios";

export const session_id = "dlx3580wyh1cybctlwzfdzo8"; //Production Session ID
// export const session_id = "ba14e03jevzpwc58itl4d8tg" //Dev Session ID

export const assistant = axios.create({
  baseURL: "https://assistant.nadu.xyz/api",
  // baseURL: "http://localhost:1337/api",
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNzM1NTU4MzE4LCJleHAiOjE5NTY0NjE1MTh9.HRoKuJAQ0Mn_vNIYHnltsbS149PqXM4VHlfI2PwtxNY",
    // "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTcsImlhdCI6MTczODE2Mzg2NiwiZXhwIjoxOTU5MDY3MDY2fQ.eN7DGJxu9rcl9_PkHP3uT5NqXkKYfjbHfcbxLCrDmsQ",
  },
});

assistant.interceptors.request.use(
  (config) => {
    config.params = { ...config.params, session_id };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);



// WEBPACK FOOTER //
// ./src/utils/axios/assistant.js